<template>
<div class="kt-alert kt-alert--outline alert alert-dismissible" :class="'alert-'+type" role="alert">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
    <span>
        <slot></slot>
    </span>
</div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'success',
        }
    }
}
</script>